module.exports = __webpack_public_path__ + "img/mont-movil.7ef4b5f8.png";